const TestDesigner = {
    "test_designer": "Test Designer",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "password": "Password",
    "profile_image": "Profile Image",
    "status": "Status",
    "search": "Search",
    "error_first_name": "Enter First Name",
    "error_last_name": "Enter Last Name",
    "error_email": "Enter Email",
    "error_phone": "Enter Phone",
    "error_password": "Enter Password",
    "error_status": "Select Status",
    "table_name": "NAME",
    "table_email": "EMAIL",
    "table_phone": "PHONE",
}

export default TestDesigner;
